import { CardNaoEncontrado } from "views/components/cards";
import { CardIndicacaoRevendedor } from "views/components/cards/card-indicacao-revendedor/card-indicacao-revendedor";
import { InformacaoIcon } from "views/components/icons";

export interface IndicacaoRevendedoresListDataProps {
    list: Array<any>;
    carregando: boolean;
    selectedList: Array<string>;
    onCardSelected: (id: string) => any;
    onCardChecked: (id: string) => any;
}

export const IndicacaoRevendedoresListData = (props: IndicacaoRevendedoresListDataProps) => {

    const onCardSelected = (id: string) => {
        props.onCardSelected(id);
    };

    // const onCardChecked = (id: string) => {
    //     props.onCardChecked(id);
    // };

    return (
        <>
            {props.list.length === 0 && !props.carregando && (
                <CardNaoEncontrado
                    mensagem="Nenhuma Indicação Encontrada."
                    icon={<InformacaoIcon tipo="GERAL" />}
                />
            )}
            {props.list.length > 0 &&
                props.list.map((instituicao, index) => {
                    return (
                        <CardIndicacaoRevendedor
                            onClick={onCardSelected}
                            model={instituicao}
                            key={index}
                        />
                    );
                })}
        </>
    );
}